// extracted by mini-css-extract-plugin
export default {"innerBox":"PostList_innerBox__42VPW","post":"PostList_post__n2JGW","loadMore":"PostList_loadMore__Vrn6t"};